import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class EntityPriorityService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/EntityPriorities`);
    }
}